class KlaviyoBackInStock {
  constructor(variantMap) {
    this.variantMap = variantMap
    this.formId = "klaviyo-backinstock"
    this.formResponse = "klaviyo-backinstock__response"
    this.variantSelectorElementId = "ProductSelect-withoutrender";
    this.selectionElement = "#klaviyo-backinstock__selection .klaviyo-backinstock__selection_title"
    this.productAtcId = "AddToCart-new-layout-product-template-onstate";
    this.variantSelectors = ".variant-picker__option-values .swatch-element"
    this.swatchSelectorInputs = ".swatch-element input"
    this.companyId = "LPcEEC";
    this.addSelectorChangeListener();
    this.addFormSubmitListener();
    this.checkSelection();
    this.currentSelection = {
        id: 0,
        title: "",
        available: true
    };
  }

  addSelectorChangeListener() {
    const variantSelect = document.querySelectorAll(
      `${this.variantSelectors}`
    );

    if (variantSelect) {
      for (const selector of variantSelect) {
        selector.addEventListener('click', () => {
            this.checkSelection()
        })
      }
    }
  }

  addFormSubmitListener() {
    const klavForm = document.getElementById(this.formId)
    klavForm.addEventListener('submit', (evt) => {
        evt.preventDefault()
        if (this.currentSelection.id !== 0 && !this.currentSelection.available) {
            const form = evt.target; 
            const formData = new FormData(form); 
            const email = formData.get('email')
            this.subscribeUserToBackInStock(email)
            this.identifyUser(email)
        }
    })
  }

  checkSelection() {
    const selections = document.querySelectorAll(
        `${this.swatchSelectorInputs}`
      );
    let currentOptions = []
    for (const selector of selections) {
        if (selector.checked) {
            currentOptions.push(selector.getAttribute('data-val'))
        }
    }

    const currentVariant = this.variantMap.find((variant) => {
        return variant?.options.every(element => currentOptions.includes(element));
    })

    if (currentVariant) {
        this.showSubcribeForm(!currentVariant.available)
        const currentSelectionElem = document.querySelector(this.selectionElement)
        currentSelectionElem.innerText = currentVariant.title
        this.currentSelection = currentVariant
    }
  }

  showSubcribeForm(visible) {
    const klavForm = document.getElementById(this.formId)
    const atc = document.getElementById(this.productAtcId)
    if (klavForm && atc) {
        klavForm.style.display = visible ? 'block' : 'none'
        atc.style.display = visible ? 'none' : 'grid'
        if (visible) {
            const klavEmail = document.getElementById('backinstock__email')
            if (klavEmail) {
                setTimeout(() => {
                    klavEmail.focus()
                }, 500)
            }
        }
    }
  }

  subscribeUserToBackInStock(email) {
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${this.currentSelection.id}`,
            },
          },
        },
      },
    };

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2023-12-15",
      },
      body: JSON.stringify(payload),
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`, requestOptions)
    .then(response => {
        if (response.ok) {
            this.displayFormResponse(`Thank you for your subscription. We will email you when the ${this.currentSelection.title} is back in stock.`, true);
        } else {
            return response.json().then(errorData => {
                throw new Error(`Server responded with an error: ${errorData.message}`);
            });
        }
    })
    .catch(error => {
        this.displayFormResponse("There seems to have been an issue with your subscription. Please try again...", false);
    });
  }

  identifyUser(emailaddress) {
    if (window.klaviyo) {
      klaviyo.push([
        "identify",
        {
          email: emailaddress,
        },
      ]);
    }
  }

  displayFormResponse(response, success) {
    const formResponseElem = document.getElementById(this.formResponse)
    formResponseElem.innerText = response
    formResponseElem.classList.add(success ? 'success' : 'error')
    formResponseElem.classList.remove(success ? 'error' : 'success')
    if (success) {
        setTimeout(() => {
            this.showSubcribeForm(false)
            formResponseElem.innerText = ""
            formResponseElem.classList.remove('success')
            formResponseElem.classList.remove('error')
            document.getElementById(this.productAtcId).style.display = 'none';
        }, 5000)
    }
  }
}
